import { Container } from '../../components/Container'
import { OfferSmeProvider } from '../../context/OfferSmeContext'
import { PageContent } from '../PageContent'
import { NewInsuranceVariantWrapper } from '../sme/NewInsuranceVariantWrapper'
import { OfferSmeGrid } from './grid/OfferSmeGrid'

export const OfferSmeCompare = ({
  onCompareClick,
}: {
  onCompareClick?: () => void
}) => {
  return (
    <OfferSmeProvider onCompareClick={() => onCompareClick && onCompareClick()}>
      <PageContent>
        <Container>
          <>{/* <OffersToolbar /> */}</>
        </Container>

        <OfferSmeGrid offerId="16834" />

        <Container>
          <NewInsuranceVariantWrapper />
        </Container>
      </PageContent>
    </OfferSmeProvider>
  )
}
